export interface DynamicTranslationsInterface {
  enUs: string
  zhCn: string
}

export class DynamicTranslations implements DynamicTranslationsInterface {
  enUs: string
  zhCn: string

  constructor(props: DynamicTranslationsInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      enUs: _enUs,
      zhCn: _zhCn,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.enUs = _enUs
    this.zhCn = _zhCn
  }
}
